import React from 'react'
import { useTranslation } from 'react-i18next'

import { LabelType } from 'types/Label'
import { Select, SelectProps } from 'components/inputs/Select/Select'
import * as Styled from './LabelTypeSelect.styles'

interface LabelTypeSelectProps extends SelectProps {
  className?: string
  label?: string
}

const LabelTypeSelect: React.FC<LabelTypeSelectProps> = ({
  className,
  label,
  ...rest
}) => {
  const { t } = useTranslation()

  return (
    <Select
      label={label}
      className={className}
      {...rest}
    >
      {Object.keys(LabelType).map((type) => (
        <Styled.MenuItem key={type} value={type}>
          {t(`labels.types.${[type]}`)}
        </Styled.MenuItem>
      ))}
    </Select>
  )
}

export { LabelTypeSelect }
